import { Component, OnInit, ViewChild, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'mkt-h-s',
  templateUrl: './mkt-slide.component.html',
  styleUrls: ['./mkt-slide.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MktSlideComponent {

  @Input() mktTitle: string = 'Marketing Title';
  @Input() mktShortDescription: string = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.';
  @Input() mktLinkUrl: string = '/search-url';
  @Input() mktLinkText: string = 'Link Text';
  // @Input() mktImage: string = '/assets/mkt-hero/img-1.jpg';
  // MktSlide Images
  mktImages = [
    'https://images.unsplash.com/photo-1504532472068-9ae844337da7?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=6e76ebffebd8e3c65985875554e36f35&auto=format&fit=crop&w=1200&q=80',
    'https://images.unsplash.com/photo-1524327952560-2ae9581d0493?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=b48ab3567e38bde596c7206f5fb7a2d6&auto=format&fit=crop&w=1200&q=80',
    'https://images.unsplash.com/photo-1507082529-e5ebd28d8ea1?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=f5850d6d4cc2a6e1f61a4aa1c8171187&auto=format&fit=crop&w=1200&q=80',
    'https://images.unsplash.com/photo-1512526825361-0918f33a9fca?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=6f07dacb0ea13892f056f96625e3bbb2&auto=format&fit=crop&w=1200&q=80',
    'https://images.unsplash.com/photo-1523612192437-66de9804ac3c?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=59310f54610ead00fcc3d07732d5d473&auto=format&fit=crop&w=1200&q=80',
    'https://images.unsplash.com/photo-1524261399568-56d8c862aaf8?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=eb319f95e1b6e9454e00526cbb0daaa4&auto=format&fit=crop&w=1200&q=80',
    'https://images.unsplash.com/photo-1494137319847-a9592a0e73ed?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=28727830d564ad4173fe58654f369fce&auto=format&fit=crop&w=1200&q=80',
  ]

  mktImage= this.mktImages[0];

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/hero/mkt-slides/mkt-slide/mkt-slide.component.ts